import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { EditButton } from 'LegacyWeployDesignLanguage/buttons';
import Highlight from 'LegacyWeployDesignLanguage/Highlight';

import DateRange from '../../common/DateRange';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: 50px;
`;

const Institution = styled.h4`
  margin-top: 0;
  margin-bottom: ${props => props.theme.space.quarter};
`;

const Education = (props) => {
  const {
    course,
    finishDate,
    id,
    institution,
    level,
    levelLabel,
    onEdit,
    searchTerms,
    startDate,
  } = props;

  const formData = {
    course,
    finishDate,
    id,
    institution,
    level,
    startDate,
  };

  const courseAndLevel = level ? `${levelLabel}, ${course}` : course;

  return (
    <Fragment>
      { onEdit &&
        <ButtonWrapper>
          <EditButton onClick={() => onEdit(formData)} />
        </ButtonWrapper>
      }
      { institution &&
        <Institution>
          <Highlight
            searchTerms={searchTerms}
            text={institution}
          />
        </Institution>
      }

      <Highlight
        searchTerms={searchTerms}
        text={courseAndLevel}
      />

      <DateRange
        startDate={startDate}
        endDate={finishDate}
      />
    </Fragment>
  );
};

Education.propTypes = {
  course: PropTypes.string.isRequired,
  id: PropTypes.string,
  level: PropTypes.string.isRequired,
  levelLabel: PropTypes.string.isRequired,
  institution: PropTypes.string,
  startDate: PropTypes.string.isRequired,
  onEdit: PropTypes.func,
  finishDate: PropTypes.string.isRequired,
  searchTerms: PropTypes.arrayOf(PropTypes.string),
};

Education.defaultProps = {
  onEdit: null,
  id: null,
  institution: null,
  searchTerms: [],
};

export default Education;
